// extracted by mini-css-extract-plugin
export default {"labelBox":"changepassword_labelBox__Hf9JV","error":"changepassword_error__GSwdz","boxShadow":"changepassword_boxShadow__mbpgq"};